import { render, staticRenderFns } from "./BookingPaymentSection.vue?vue&type=template&id=e946f070&"
import script from "./BookingPaymentSection.vue?vue&type=script&lang=js&"
export * from "./BookingPaymentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports